import { ReactElement } from 'react'
import Add from '@mui/icons-material/Add'
import Cancel from '@mui/icons-material/Cancel'
import { IconButton, Stack, Tooltip, Typography } from '@mui/material'

interface Props {
  label: string
  /** True while none of the supports the button covers is left in the edit. */
  isExcluded: boolean
  /** Removes those supports from every member at once, or adds them back. */
  onToggle: () => void
  /** Tooltip of the button, which reads differently per state. */
  removeTooltip: string
  addTooltip: string
  /** The Element header sits above left-aligned cells, the support ones are centered. */
  justifyContent?: 'center' | 'flex-start'
  dataCy: string
}

/**
 * Header cell of the support matrix with the button that takes the supports it
 * stands for — one column, or all of them — out of the edit in one go.
 */
const SupportColumnHeader = ({
  label,
  isExcluded,
  onToggle,
  removeTooltip,
  addTooltip,
  justifyContent = 'center',
  dataCy,
}: Props): ReactElement => (
  <Stack direction="row" alignItems="center" justifyContent={justifyContent}>
    {/* 500 = the DataGrid's default header title weight, which a custom
        renderHeader does not inherit (only the default title element carries it). */}
    <Typography sx={{ fontWeight: 500, fontSize: 'inherit' }}>{label}</Typography>
    <Tooltip title={isExcluded ? addTooltip : removeTooltip}>
      <IconButton
        size="small"
        sx={{ p: 0.25 }}
        onClick={onToggle}
        data-cy={`${dataCy}-${isExcluded ? 'add' : 'remove'}`}
      >
        {isExcluded ? <Add sx={{ fontSize: 16 }} /> : <Cancel sx={{ fontSize: 16 }} />}
      </IconButton>
    </Tooltip>
  </Stack>
)

export default SupportColumnHeader
